<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showAddEmployee"
        class="bg-black fixed h-screen bg-opacity-70 inset-0 z-50 w-full"
      >
        <form
          @submit.prevent="submitForm"
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 w-full overflow-y-auto"
          style="height: auto"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-50 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Update {{ activeTitle }}</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>

          <div class="p-4 grid grid-cols-2 gap-4">
            <div
              class="text-sm col-span-1"
              v-for="(info, index) in empData"
              :key="index"
            >
              <label class="block pb-1">{{ info.name }}</label>
              <div v-if="info.type === 'date'">
                <input
                  :type="info.type"
                  v-model="info.value"
                  required
                  class="p-2 bg-gray-200 rounded-md w-full"
                />
              </div>

              <div v-else-if="info.type !== 'select'">
                <input
                  v-model="info.value"
                  :name="decryptDataLocal(info.name, decryptionKey)"
                  :type="info.type"
                  class="p-2 bg-gray-200 rounded-full w-full"
                />
              </div>

              <div class="relative">
                <select
                  v-if="info.type === 'select' && info.name === 'County'"
                  class="w-full rounded-full"
                  v-model="info.value"
                  @change="() => getSubCounties(info.value)"
                  aria-label="Select a county"
                >
                  <option value="" disabled>Select a county</option>
                  <option
                    v-for="(option, index) in info.options"
                    :key="index"
                    :value="option.name"
                  >
                    {{ option.name }}
                  </option>
                </select>

                <select
                  v-else-if="
                    info.type === 'select' && info.name === 'Sub County'
                  "
                  class="w-full rounded-full"
                  v-model="info.value"
                  @change="() => getSubCountiesByActiveCounty()"
                  aria-label="Select a sub county"
                >
                  <option value="" disabled>Select a sub county</option>
                  <option
                    v-for="(option, index) in subCountiesToSelect"
                    :key="index"
                    :value="option"
                  >
                    {{ option }}
                  </option>
                </select>

                <select
                  v-else-if="
                    info.type === 'select' &&
                    info.name !== 'County' &&
                    info.name !== 'Sub County'
                  "
                  class="w-full rounded-full"
                  v-model="info.value"
                  aria-label="Select an option"
                >
                  <option value="" disabled>Select an option</option>
                  <option
                    v-for="(option, index) in info.options"
                    :key="index"
                    :value="option"
                  >
                    {{ option }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>
<script>
import axios from "axios";
import Loader from "@/components/loader/loader.vue";
import { mapGetters } from "vuex";
import { kenyanCounties } from "@/utils/utilsData";
import decryptData from "@/utils/decrypt";
import moment from "moment";

export default {
  name: "EditEmployee",
  props: [
    "showAddEmployee",
    "personalInfo",
    "homeAndContactInfo",
    "emergencyContactInfo",
    "sectionData",
    "empData",
    "reload",
    "getEditError",
    "getEditSuccess",
    "flushMessages",
    "activeTitle",
    "itemIndex",
  ],
  components: { Loader },
  data() {
    return {
      loading: false,
      showUpdateSuccess: null,
      create_error: null,
      dateFormat: "DD/MM/YYYY", // Adjust the date format as needed
      selectedOptionIndex: null,
      subCountiesToSelect: [],
      DateofBirth: "",
    };
  },

  computed: {
    ...mapGetters(["getOrganization", "getToken", "getTabTitle"]),
  },

  created() {
    this.decryptDataLocal = decryptData;
    this.decryptionKey = this.$decryptionKey;
    this.empData.forEach((info) => {
      info.value = decryptData(info.value, this.$decryptionKey) || "";
      if (info.name === "Date of Birth" && info.type === "date") {
        const date = new Date(info.value);
        info.value = moment(date).format("YYYY-MM-DD");
        this.DateofBirth = info.value;
      }
    });
  },

  // watch:

  methods: {
    getSubCounties(countyName) {
      this.subCountiesToSelect = kenyanCounties.find(
        (name) => name.name === countyName
      ).sub_counties;
    },
    getSubCountiesByActiveCounty() {
      let activeCounty = this.homeAndContactInfo[2]?.value;
      console.log(activeCounty);
      this.subCountiesToSelect = kenyanCounties.find(
        (name) => name.name === activeCounty
      ).sub_counties;
    },
    close() {
      this.$emit("close");
      this.reload();
    },
    submitForm() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      // Extract existing data
      const existingData = {
        ...this.personalInfo.reduce(
          (obj, info) => ({
            ...obj,
            [info.label]: info.value,
          }),
          {}
        ),
        ...this.homeAndContactInfo.reduce(
          (obj, info) => ({
            ...obj,
            [info.label]: info.value,
          }),
          {}
        ),
        ...this.emergencyContactInfo.reduce(
          (obj, info) => ({
            ...obj,
            [info.label]: info.value,
          }),
          {}
        ),
      };

      // Combine existing data with new data
      const requestData = {
        ...existingData,
        ...this.personalInfo.reduce(
          (obj, info) => ({
            ...obj,
            [info.label]:
              decryptData(info.value, this.$decryptionKey) ||
              existingData[info.label],
          }),
          {}
        ),
        ...this.homeAndContactInfo.reduce(
          (obj, info) => ({
            ...obj,
            [info.label]:
              decryptData(info.value, this.$decryptionKey) ||
              existingData[info.label],
          }),
          {}
        ),
        ...this.emergencyContactInfo.reduce(
          (obj, info) => ({
            ...obj,
            [info.label]:
              decryptData(info.value, this.$decryptionKey) ||
              existingData[info.label],
          }),
          {}
        ),
        Id: this.personalInfo[0]?.Id, // Ensure Id is present
      };

      // console.log(requestData);

      axios
        .put(
          `${this.getOrganization}/employee/general/${this.$ApiVersion}/edit`,
          JSON.stringify(requestData),
          options
        )
        .then((response) => {
          this.loading = false;
          if (response.data.StatusCode === 200) {
            this.showUpdateSuccess = response.data.StatusMessage;
            this.reload();
            this.getEditSuccess(this.showUpdateSuccess, this.itemIndex);
            setTimeout(() => {
              this.showUpdateSuccess = null;
              this.$emit("closeOnSuccess", response.data.StatusMessage);
              this.flushMessages();
            }, 2000);
          } else {
            this.create_error = response.data.StatusMessage;
            this.getEditError(this.create_error);
            setTimeout(() => {
              this.create_error = null;
              this.flushMessages();
            }, 2000);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.create_error = error.message;
          setTimeout(() => {
            this.create_error = null;
            this.flushMessages();
          }, 2000);
        });
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>

{ "Id": "string", "FullNames": "string", "Nationality": "string",
"PersonalEmail": "string", "MaritalStatus": "string", "Religion": "string",
"DateofBirth": "2024-08-05T15:08:31.839Z", "PersonalPhoneNumber": "string",
"Gender": "string", "NationalID": "string", "KRAPINNumber": "string",
"NSSFNumber": "string", "NHIFNumber": "string", "Street": "string", "Country":
"string", "County": "string", "SubCounty": "string", "Town": "string",
"PostalAddress": "string", "PostalCode": "string", "HomeEmail": "string", }
SELECT pt.name AS 'Payment Type', CONCAT('Ksh ', FORMAT(SUM(p.amount), 2)) AS
'Total', (SELECT CONCAT('Ksh ', FORMAT(SUM(amount), 2)) FROM payments WHERE
when_added BETWEEN '2024-06-01' AND '2024-06-30' ) AS 'Cumulative Total' FROM
payments p JOIN payment_types pt ON p.pay_type = pt.id WHERE p.when_added
BETWEEN '2015-01-01' AND '2023-12-31' GROUP BY pt.name;
